// src/components/layout/VideoUploadSection.js - verification video card of a choreography.
// Thin wrapper around the shared MediaUploadCard (audit FL-39). The backend accepts the
// verification video in every status, so it is editable unless the competition is locked.
import React from 'react';
import MediaUploadCard from '../leader/MediaUploadCard';

const VideoUploadSection = ({ choreographyId, verificationVideo, onVideoUploaded, editable = true, lockedReason }) => (
  <MediaUploadCard
    kind="verification"
    choreographyId={choreographyId}
    file={verificationVideo}
    editable={editable}
    lockedReason={lockedReason}
    onUploaded={onVideoUploaded}
  />
);

export default VideoUploadSection;
